module.exports = __webpack_public_path__ + "img/undraw_At_work_re_qotl.60b188ac.svg";